import React from 'react'

const EmailIcon: React.FC<{ className?: string }> = ({ className }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 64 64"
      fill="currentColor"
      className={className}
      style={{ display: 'block' }}
    >
      {/* Envelope Main Body */}
      <path d="M63.55,53.76H.45V14.31h63.1ZM4.39,49.81H59.61V18.26H4.39Z" />

      {/* Envelope Flap / V-Shape */}
      <polygon points="32 36.33 1.4 17.98 3.43 14.59 32 31.73 60.57 14.59 62.6 17.98 32 36.33" />
    </svg>
  )
}

export default EmailIcon
